declare namespace $ {

	type $mol_view__sub_rise_radio_1 = $mol_type_enforce<
		ReturnType< $rise_radio['circle_inner'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $rise_radio extends $mol_switch {
		Circle_inner( id: any): $mol_view
		circle_inner( id: any): readonly(any)[]
		Circle( id: any): $mol_view
		option_label( id: any): readonly(any)[]
	}
	
}

//# sourceMappingURL=radio.view.tree.d.ts.map